var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMustard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3773 0H16.6227L14.5133 8.50781H22.4867L20.3773 0Z",
    fill: "#FEBE39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4867 8.50781H18.5V0H20.3773L22.4867 8.50781Z",
    fill: "#E9A71E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1719 6.39844V12.7266H24.8281V6.39844H12.1719Z",
    fill: "#FF9595"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8281 6.39844H18.5V12.7266H24.8281V6.39844Z",
    fill: "#FF4E4E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9375 16.9453L20.3562 28.6734L26.9375 31.7109V36H10.0625V10.6172H26.9375V16.9453Z",
    fill: "#FEBE39"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9375 21.1641L25.6297 22.1554L26.9375 23.2734V25.3828L25.6297 26.6906L26.9375 27.4922V31.7109H14.2812V16.9453H26.9375V21.1641Z",
    fill: "#FAECD8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9375 16.9453L20.3562 28.6734L26.9375 31.7109V36H18.5V10.6172H26.9375V16.9453Z",
    fill: "#E9A71E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9375 21.1641L25.6297 22.1554L26.9375 23.2734V25.3828L25.6297 26.6906L26.9375 27.4922V31.7109H18.5V16.9453H26.9375V21.1641Z",
    fill: "#F4D7AF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9375 21.1641H18.5V23.2734H26.9375V21.1641Z",
    fill: "#FF4E4E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9375 25.3828H18.5V27.4922H26.9375V25.3828Z",
    fill: "#FF4E4E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMustard);
export default __webpack_public_path__ + "static/media/mustard.3a0165e1ddd43cd11f0226917a8297ed.svg";
export { ForwardRef as ReactComponent };